import {
    getUser
} from '@/helpers/api'


const state = () => ({
    data: null,
})

const getters = {
  
}

const actions = {
    async FETCH_USER ({ commit, state }) {

        //if (state.data) return
        
        let resp = null
        try {
            resp = await getUser()
        } catch (e) {
            resp = e
        }

        if (resp && resp.status == 200 && resp.data) {
            commit('setUser', resp.data)
        }

        return resp
    }
}

const mutations = {
  setUser (state, data) {
    state.data = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}